var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { StakeHolder } from "../StakeHolder";
import { Dropdown } from "sb-resp-ui";
var StakeType = /** @class */ (function (_super) {
    __extends(StakeType, _super);
    function StakeType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StakeType.prototype.render = function () {
        return (this.props.isFreeBetView
            ? React.createElement(Dropdown, { data: this.props.freebetData, selectItem: this.props.dropdownHandler, blockName: "pulse-bet", defaultText: this.props.defaultText })
            : React.createElement(StakeHolder, { data: this.props.stakeData }));
    };
    return StakeType;
}(React.Component));
export { StakeType };
//# sourceMappingURL=StakeType.js.map